import React, {useState, useContext} from 'react';
import { Alert, Form, Input, CardColumns, Progress } from 'reactstrap';
import Carddass from './Carddass';
import { CarddassContext, UserContext } from '../../contexts';

export default function CarddassList(props) {
    const {cards, searchable, showPerComplete, showAll, selectedCards, setSelectedCards} = props;
    const [keyword, setKeyword] = useState("");
    const user = useContext(UserContext);
    const allCards = useContext(CarddassContext);

    function handleKeywordChange(event) {
        setKeyword(event.target.value);
    }

    function toggleSelect(cardId) {
        if(selectedCards && setSelectedCards) {           
            if(selectedCards.find(value => value === cardId)) {
                setSelectedCards(prev => prev.filter(value => value !== cardId));
            } else {
                setSelectedCards(prev => [...prev, cardId]);
            }
        }
    }

    const cardList = cards
        .filter(card => ((selectedCards && card.id in selectedCards) || (keyword === "" || 0 <= card.title.indexOf(keyword))))
        .map(card => {
            let count = 0;
            if(user.cardlist) {
                const col = user.cardlist[card.id];
                if(col) count = col.count;
            }
            if(showAll) count = -1;

            let selected;
            if(selectedCards) selected = (selectedCards.find(value => value === card.id) != null);

            return (<Carddass key={card.id} card={card} count={count} selected={selected} setSelected={toggleSelect} />);
        });

    const ownedCount = user.cardlist ? allCards.filter(card => (user.cardlist[card.id] && 0 < user.cardlist[card.id].count)).length : 0;
    const perComplete = (ownedCount / allCards.length) * 100;

    let selectedCardMessage = "";
    if(selectedCards &&  selectedCards.length > 0) {
        selectedCardMessage = selectedCards.length + "枚選択中 (" + selectedCards.map(id => allCards.find(card => card.id === id).title).join(", ") + ")";
    }

    return(
        <div>
            {showPerComplete &&
            <Alert className="per-complete" color="info">
                <p>現在{ownedCount}種類のカードダスを持っています。</p>
                <div className="d-flex">
                    <Progress className="flex-grow-1 align-self-center" value={perComplete}></Progress>
                    <div className="pl-2">{perComplete}%</div>
                </div>
            </Alert>
            }
            {selectedCardMessage &&
            <Alert color="info">{selectedCardMessage}</Alert>
            }
            {searchable &&
            <div className="mb-3">
                <Form onSubmit={(e) => e.preventDefault()} className="carddass-search">
                    <Input type="text" value={keyword} placeholder="検索..." onChange={handleKeywordChange} className="nozoom"/>
                </Form>
            </div>
            }
            <CardColumns className="carddass-list">
                {cardList}
            </CardColumns>
        </div>
    );
}